"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalWindow = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _antd = require("antd");

var _modalTypes = require("../../constants/modalTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ModalWindow =
/*#__PURE__*/
function (_Component) {
  _inherits(ModalWindow, _Component);

  function ModalWindow() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalWindow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalWindow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var closeModal = _this.props.closeModal;
      closeModal();
    });

    return _this;
  }

  _createClass(ModalWindow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          translate = _this$props.translate,
          visible = _this$props.visible; // TODO: implement custom modal type

      var type = this.props.type || _modalTypes.MODAL_TYPES.DEFAULT,
          text = translate(this.props.text),
          title = translate(this.props.title),
          buttonText = translate(this.props.buttonText || 'buttons/OK'); // TODO: check if this functional is used
      // const onClose = () => {
      //     this.onClose(modal.onClose);
      // };
      // TODO: check if this functional is used
      // const onOkClick = typeof modal.onOK === 'function' ? modal.onOK : onClose;

      var style = {
        overlay: {
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.75)'
        },
        content: {
          position: 'relative',
          top: '30%',
          left: 0,
          right: 0,
          bottom: 0,
          textAlign: 'center',
          width: '500px',
          height: '200px',
          margin: '0 auto'
        }
      };
      var className = type === _modalTypes.MODAL_TYPES.ERROR ? 'error-modal' : 'default-modal';
      return _react["default"].createElement("div", {
        className: "modal-window"
      }, visible && _react["default"].createElement(_reactModal["default"], {
        portalClassName: className,
        style: style,
        isOpen: visible,
        ariaHideApp: false,
        onRequestClose: this.handleClose
      }, _react["default"].createElement("h1", null, title), _react["default"].createElement("p", null, text), _react["default"].createElement(_antd.Button, {
        type: "primary",
        onClick: this.handleClose
      }, buttonText)));
    }
  }]);

  return ModalWindow;
}(_react.Component);

exports.ModalWindow = ModalWindow;